import { render, staticRenderFns } from "./inspection-view-image.vue?vue&type=template&id=371fea68&scoped=true"
import script from "./inspection-view-image.vue?vue&type=script&lang=js"
export * from "./inspection-view-image.vue?vue&type=script&lang=js"
import style0 from "./inspection-view-image.vue?vue&type=style&index=0&id=371fea68&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371fea68",
  null
  
)

export default component.exports